//#region TextareaDimensions Type

/**
 * Type defining the dimensions and constraints for textarea auto-resize functionality.
 */
export type TextareaDimensions = {
	/** The final calculated height for the textarea */
	height: number;
	/** The minimum allowed height */
	minHeight: number;
	/** The maximum allowed height */
	maxHeight: number;
	/** Whether scrollbar should be shown when content exceeds max height */
	shouldShowScrollbar: boolean;
	/** The natural content height before constraints */
	contentHeight: number;
};

//#endregion
